import React from 'react';
import Link from 'gatsby-link';
import { FormattedMessage } from "react-intl";


import "../styles/Footer.scss";



const Footer = ({ langs }) => (
  <footer className="Footer" id="footer">
    <div className="container grid-lg">
      <div className="disclaimer">
        <p>
          <FormattedMessage id="disclaimer" />
        </p>
      </div>
      <div>
        <div className="text-center">
          <a href="https://freemigrationproject.org/" target="_blank">
            Free Migration Project
          </a>{" "}
          © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
